import React, { Component } from 'react'
import '../../styles/GlobalStyle.css'
import { firebase, db } from '../../firebase/Firebase'
import PersonAvatar from '../../customcomponents/PersonAvatar'
//import IEPDrafts from './IEPDrafts'
import ColType from '../.././Types'
import { flattenDoc, getIDFromURL, getQueryStringParam, capitalizeFirstChar, getStrengths } from '../.././Util'
import { Layout, Button, Select, Form, Radio } from 'antd'
//import CustomFooter from '../../ login / CustomFooter'
import DraftStepContainer from './DraftStepContainer'
const { Content } = Layout
const Option = Select.Option
const FormItem = Form.Item
const RadioGroup = Radio.Group

class TeacherAddIEPGoalStudent extends Component {
  state = {
    teacherId: null,
    studentId: null,
    teacher: null,
    selectedStudent: null,
    students: [],
    studentDict: {},
    iepDrafts: [],
    tabKey: '1',
    iepDraft: null,
    iepDraftMounted: false,
    selectedSubjects: [],
    studentStrengths: getStrengths(),
    selectedMenuKey: 'currentDraft',
  }

  componentDidMount() {
    document.title = 'Draft IEP - Dot It'
    var teacherId = getIDFromURL(window.location)
    var draftId = getQueryStringParam('draft')
    var iepDraft = this.props.history.location.state
    console.log("mount",
      this.props.teacherBaseProps, teacherId, iepDraft)

    window.scrollTo(0, 0)

    this.setState({
      teacherId: teacherId,
      draftId: draftId,
      tabKey: '1',
    })

    // selectedStudent is set by syncSelectedStudent once the student list
    // and/or the draft have loaded (whichever finishes last wins).

    if (draftId) {
      db.collection(ColType.iepDrafts)
        .doc(draftId)
        .get()
        .then((doc) => {
          this.setState({
            iepDraft: flattenDoc(doc),
            iepDraftMounted: true,
          }, () => {
            iepDraft = this.state.iepDraft
            if (iepDraft &&
              !(Object.keys(iepDraft).length === 0 &&
                iepDraft.constructor === Object)) {
              this.setState({
                selectedSubjects: iepDraft.subject,
              }, () => {
                var formObj = {
                  studentId: iepDraft.studentId,
                  subject: iepDraft.subject,
                  category: iepDraft.category,
                  level: iepDraft.selectedLevel,
                }
                Object.keys(iepDraft).map((key, idx) => {
                  if (key.indexOf("strength-") !== -1) {
                    formObj[key] = iepDraft[key]
                  }
                  return false
                })
                this.props.form.setFieldsValue(formObj)
                this.syncSelectedStudent()
              })
            }
          })
        })
    } else {
      this.setState({
        iepDraftMounted: true,
      })
    }

    db.collection(ColType.teacher)
      .doc(teacherId)
      .get()
      .then((doc) => {
        var teacher = flattenDoc(doc)

        this.setState({
          teacher: teacher,
        })
      })

    db.collection(ColType.student)
      .where('teacherId', '==', teacherId)
      .get()
      .then((querySnapshot) => {
        var students = []
        var studentDict = {}
        querySnapshot.forEach((doc) => {
          //console.log(doc.id, ' => ', doc.data())
          var student = flattenDoc(doc)
          students.push(student)
          studentDict[student.id] = student
        })

        students.sort((a, b) => {
          if (a.grade === 'K' && b.grade === 'K') {
            if (a.lastName.charAt(0) > b.lastName.charAt(0)) {
              return 1
            } else {
              return -1
            }
          }
          if (a.grade === 'K' && b.grade !== 'K') return -1
          if (a.grade !== 'K' && b.grade === 'K') return 1
          if (a.grade === b.grade) {
            if (a.lastName.charAt(0) > b.lastName.charAt(0)) {
              return 1
            } else {
              return -1
            }
          }
          var aGrade = parseInt(a.grade, 10)
          var bGrade = parseInt(b.grade, 10)
          if (aGrade > bGrade) return 1
          if (bGrade > aGrade) return -1
          return 0
        })

        this.setState({
          students: students,
          studentDict: studentDict,
        }, this.syncSelectedStudent)
      })
  }

  // add a new event to the teacher's events
  handleSubmit = (e) => {
    e.preventDefault()
    this.props.form.validateFields((err, values) => {
      if (!err) {
        // only used for clicking back on this step to set the form value
        values.selectedLevel = values.level
        var belowSeventy = '70 and below'
        var belowEighty = '70-79'
        var aboveEighty = '80 and above'
        if (values.level < 70) values.level = belowSeventy
        else if (values.level < 80) values.level = belowEighty
        else values.level = aboveEighty

        values.studentId = values.studentId
        values.teacherId = this.state.teacher.id
        values.schoolId = this.state.teacher.schoolId
        values.districtId = this.state.teacher.districtId
        values.timeStamp = firebase.firestore.FieldValue.serverTimestamp()
        values.step = { stepNum: 1, path: 'information' }

        if (this.state.draftId) {
          db.collection(ColType.iepDrafts)
            .doc(this.state.draftId)
            .set(values)
            .then(() => {
              console.log("Document set with ID: ", this.state.draftId)
              this.props.history.push(
                {
                  pathname: '/teacher/add-goal-information/' +
                    this.state.teacherId + '?student=' +
                    values.studentId +
                    '&draft=' + this.state.draftId,
                  state: values, // pass state to confirm page
                }
              )
            })
            .catch((error) => {
              console.log(error)
            })
        }
        else {
          db.collection(ColType.iepDrafts)
            .add(values)
            .then((docRef) => {
              console.log("Document written with ID: ", docRef.id)
              this.props.history.push(
                {
                  pathname: '/teacher/add-goal-information/' +
                    this.state.teacherId + '?student=' +
                    values.studentId +
                    '&draft=' + docRef.id,
                  state: values, // pass state to confirm page
                }
              )
            })
            .catch((error) => {
              console.log(error)
            })
        }
      }
    })
  }

  tabChange = (activeKey) => {
    this.setState({ tabKey: activeKey })
  }

  getStudent = (studentId) => {
    if (!studentId) return null
    const dict = this.state.studentDict
    if (dict && dict.hasOwnProperty(studentId)) return dict[studentId]
    const propDict = this.props.teacherBaseProps.studentDict
    if (propDict && propDict.hasOwnProperty(studentId)) return propDict[studentId]
    return null
  }

  // true if the student is K-5 (or no student is selected yet)
  isElementaryGrade = (student) => {
    if (!student) return true
    const grade = student.grade
    if (typeof grade === 'string') {
      const g = grade.trim().toLowerCase()
      if (g === 'k' || g === 'kindergarten') return true
    }
    const n = this.toInt(grade)
    return !isNaN(n) && n <= 5
  }

  // Sets selectedStudent from the form value (draft) or the ?student= param,
  // once the student list is available. Only selects students that exist.
  syncSelectedStudent = () => {
    const formId = this.props.form.getFieldValue('studentId')
    const studentId = formId || getQueryStringParam('student')
    const student = this.getStudent(studentId)
    if (!student) return

    if (!formId) this.props.form.setFieldsValue({ studentId })
    this.setState({ selectedStudent: student })
  }

  studentChange = (value) => {
    const student = this.getStudent(value)
    let selectedSubjects = this.state.selectedSubjects

    // remove reading foundations if the student is above grade 5
    if (!this.isElementaryGrade(student)) {
      selectedSubjects = selectedSubjects.filter(s => s !== 'Reading Foundations')
      this.props.form.setFieldsValue({ subject: selectedSubjects })
    }

    this.setState({
      selectedStudent: student,
      selectedSubjects: selectedSubjects,
    })
  }

  subjectChange = (values) => {
    this.setState({
      selectedSubjects: values,
    })
  }

  draftTabOnChange = (key) => {
    this.setState({ selectedMenuKey: key })
  }

  menuClick = (e) => {
    this.setState({
      selectedMenuKey: e.key,
    })
  }

  toInt(value) {
    if (typeof value === "number") return value
    if (typeof value === "string") return parseInt(value, 10)
    return NaN
  }

  getStrengthKey = (student) => {
    if (!student || this.isElementaryGrade(student)) {
      const n = student ? this.toInt(student.grade) : NaN
      if (n >= 3 && n <= 5) return "35"
      return "K2" // K, 1, 2, or no student selected
    }
    const n = this.toInt(student.grade)
    if (n >= 6 && n <= 8) return "68"
    if (n >= 9 && n <= 12) return "912"
    return "K2"
  }

  render() {
    const { getFieldDecorator } = this.props.form

    const formItemBlockLayout = {
      labelCol: {
        xs: { span: 24 },
        sm: { span: 24 },
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 24 },
      },
    }

    const selectedStudent = this.state.selectedStudent
    const isElementary = this.isElementaryGrade(selectedStudent)
    const strengthKey = this.getStrengthKey(selectedStudent)

    return (
      <div>
        <Layout className="content layout-header-mt">
          <Layout>
            <Content className="min-w-1120">
              <div>
                {/* 
                <div className="text-center">
                  <img src="/draft-plan/3.png" alt="steps" />
                </div>
                */}
                <DraftStepContainer
                  teacherBaseProps={this.props.teacherBaseProps}
                  dataLoaded={true}
                >
                  <div>
                    <div className="w-800 m-lr-auto background-fff br-15">
                      <div className='p-4 bkg-purple br-15'>
                        <div className='flex flex-v-center w-100'>
                          <div>
                            <h1 className="font-bold mb-0 font-40 font-fff">Draft an IEP</h1>
                            <h2 className="mb-3 font-24 font-fff">Student Information</h2>
                          </div>
                          <img src="/draft-icons/1.png" alt='draft-iep' width={250} className='ml-auto' />
                        </div>
                      </div>

                      <div className='p-4'>
                        <Form onSubmit={this.handleSubmit}
                          className="login-form text-align-left">
                          <FormItem {...formItemBlockLayout}
                            label={<div>
                              <div className='font-20 font-bold'>
                                Student
                              </div>
                              <div className='font-16 font-normal'>
                                To draft an IEP, select a student below.
                              </div>
                            </div>} className="block-label">
                            {getFieldDecorator('studentId', {
                              rules: [{ required: true, message: 'Select a student.' }],
                            })(
                              <Select
                                showSearch
                                className="ant-select-very-large"
                                placeholder="Select student"
                                onChange={this.studentChange}
                              >
                                {this.props.teacherBaseProps.students &&
                                  this.props.teacherBaseProps.students.map((student, index) => {
                                    return <Option value={student.id} key={"student-" + index}>
                                      <PersonAvatar
                                        size={'default'}
                                        person={student}
                                      />
                                    </Option>
                                  })
                                }
                              </Select>
                            )}
                          </FormItem>

                          {isElementary ?
                            <FormItem {...formItemBlockLayout}
                              label={<div>
                                <div className='font-20 font-bold'>
                                  Content areas
                                </div>
                                <div className='font-16 font-normal'>
                                  Select all content areas that apply. A goal will be generated for each content area selected.
                                </div>
                              </div>}
                              className="block-label">
                              {getFieldDecorator('subject', {
                                rules: [{
                                  required: true,
                                  message: 'Select all content areas that apply.'
                                }],
                              })(
                                <Select
                                  mode="multiple"
                                  size={'large'}
                                  placeholder="Select all content areas that apply"
                                  onChange={this.subjectChange}
                                >
                                  <Option value={'Reading Comprehension in Literature'}>
                                    Reading Comprehension in Literature
                                  </Option>
                                  <Option value={'Reading Comprehension in Informational Text'}>
                                    Reading Comprehension in Informational Text
                                  </Option>
                                  <Option value={'Reading Foundations'}>
                                    Reading Foundational Skills
                                  </Option>
                                  <Option value={'Math'}>
                                    Math
                                  </Option>
                                  <Option value={'Writing'}>
                                    Writing
                                  </Option>
                                  <Option value={'Social Emotional Learning'}>
                                    Social Emotional Learning
                                  </Option>
                                </Select>
                              )}
                            </FormItem>
                            :
                            <FormItem {...formItemBlockLayout}
                              label={<div>
                                <div className='font-20 font-bold'>
                                  Content areas
                                </div>
                                <div className='font-16 font-normal'>
                                  Select all content areas that apply. A goal will be generated for each content area selected.
                                </div>
                              </div>}
                              className="block-label">
                              {getFieldDecorator('subject', {
                                rules: [{
                                  required: true,
                                  message: 'Select all content areas that apply.'
                                }],
                              })(
                                <Select
                                  mode="multiple"
                                  size={'large'}
                                  placeholder="Select all content areas that apply"
                                  onChange={this.subjectChange}
                                >
                                  <Option value={'Reading Comprehension in Literature'}>
                                    Reading Comprehension in Literature
                                  </Option>
                                  <Option value={'Reading Comprehension in Informational Text'}>
                                    Reading Comprehension in Informational Text
                                  </Option>
                                  <Option value={'Math'}>
                                    Math
                                  </Option>
                                  <Option value={'Writing'}>
                                    Writing
                                  </Option>
                                  <Option value={'Social Emotional Learning'}>
                                    Social Emotional Learning
                                  </Option>
                                </Select>
                              )}
                            </FormItem>
                          }


                          <FormItem {...formItemBlockLayout} label={<div>
                            <div className='font-20 font-bold'>
                              Impact
                            </div>
                            <div className='font-16 font-normal'>
                              Based on the student's psychological evaluation, access to the general curriculum is impacted most by weaknesses in this impact category.
                            </div>
                          </div>}
                            className="block-label">
                            {getFieldDecorator('category', {
                              rules: [{ required: true, message: 'Select greatest impact.' }],
                            })(
                              <Select
                                size={'large'}
                                placeholder="Select impact">
                                <Option value={'WMI'}>
                                  Working Memory
                                </Option>
                                <Option value={'PSI'}>
                                  Processing Speed
                                </Option>
                                <Option value={'FRI'}>
                                  Fluid Reasoning
                                </Option>
                                <Option value={'VSI'}>
                                  Visual Spatial Processing
                                </Option>
                                <Option value={'VCI'}>
                                  Verbal Comprehension
                                </Option>
                              </Select>
                            )}
                          </FormItem>

                          <FormItem {...formItemBlockLayout}
                            label={"On this index, the student scored"}
                            className="block-label">
                            {getFieldDecorator('level', {
                              rules: [{ required: true, message: 'Select score' }],
                            })(
                              <RadioGroup>
                                <Radio className="block mt-05" value={69}>
                                  <span className='font-16 va-minus-3'>
                                    Extremely Low (69 or below)
                                  </span>
                                </Radio>
                                <Radio className="block mt-05" value={79}>
                                  <span className='font-16 va-minus-3'>
                                    Very Low (70-79)
                                  </span>
                                </Radio>
                                <Radio className="block mt-05" value={89}>
                                  <span className='font-16 va-minus-3'>
                                    Low Average (80-89)
                                  </span>
                                </Radio>
                                <Radio className="block mt-05" value={109}>
                                  <span className='font-16 va-minus-3'>
                                    Average (90-109)
                                  </span>
                                </Radio>
                                <Radio className="block mt-05" value={119}>
                                  <span className='font-16 va-minus-3'>
                                    High Average (110-119)
                                  </span>
                                </Radio>
                                <Radio className="block mt-05" value={129}>
                                  <span className='font-16 va-minus-3'>
                                    Very High (120-129)
                                  </span>
                                </Radio>
                              </RadioGroup>
                            )}
                          </FormItem>

                          {this.state.selectedSubjects.length > 0 ?
                            <div className="font-30 mb-2 font-black">
                              Student strengths by content area
                            </div>
                            : ''}
                          {this.state.selectedSubjects.map((subject, idx) => {
                            return <FormItem {...formItemBlockLayout}
                              key={'strength-item-' + subject}
                              label={<div>
                                <div className='font-20 font-bold'>
                                  {subject}
                                </div>
                                <div className='font-16 font-normal'>
                                  Choose a strength the student has in {subject}.
                                </div>
                              </div>}
                              className="block-label">
                              {getFieldDecorator('strength-' + subject, {
                                rules: [{ required: true, message: 'Select greatest impact.' }],
                              })(
                                <Select
                                  size={'large'}
                                  placeholder="Select strength..."
                                  key={'strength-select-' + subject}>
                                  {this.state.studentStrengths[strengthKey][subject].map((strength, idx) => {
                                    return <Option value={strength} key={'strength-option-' + subject + '-' + strength + '-' + idx}>
                                      {capitalizeFirstChar(strength)}
                                    </Option>
                                  })}
                                </Select>
                              )}
                            </FormItem>
                          })}

                          <FormItem className="mb-0">
                            <Button
                              type="primary"
                              htmlType="submit"
                              className="lg-btn float-right"
                            >
                              Continue
                            </Button>
                          </FormItem>
                        </Form>
                      </div>
                    </div>
                  </div>
                </DraftStepContainer >

              </div>
            </Content>
          </Layout>
        </Layout>
      </div>
    )
  }
}

export default Form.create()(TeacherAddIEPGoalStudent)